import { InputSwitch } from 'primereact/inputswitch';
import React, { useState } from 'react';
import { updateBrandBannerStatus } from '../../../services/BrandBanner/BrandBanner';

const BrandBannerStatusChange = ({
  status,
  editData,
  sendDataToBannerList,
  brandId,
}) => {
  const [statusValue, setStatusValue] = useState(status === true);

  const handleEditData = (e) => {
    const newStatus = e.value;
    setStatusValue(newStatus);

    const bannerId = editData.id;

    updateBrandBannerStatus(brandId, bannerId)
      .then((response) => {
        if (!response.data.error) {
          sendDataToBannerList({
            success: true,
          });
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  return (
    <div style={{ margin: "10px 0 10px 5px" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          borderRadius: "15px",
          width: "100%",
        }}
      >
        <InputSwitch checked={statusValue} onChange={handleEditData} />
      </div>
    </div>
  );
};

export default BrandBannerStatusChange;
